<template>
    <v-select
            v-model="currSel"
            v-bind:items="items"
            item-text="name"
            item-value="name"
            return-object
            :label="options.label"
            :solo="options.solo"
            @change="options.changeCallback(currSel)"
    >

        <template slot="selection" slot-scope="data">
            <v-flex shrink>
                <v-avatar v-if="data.item.image" size="25px">
                    <v-img :src="data.item.image"></v-img>
                </v-avatar>
                <v-avatar v-else-if="data.item.icon" size="25px">
                    <v-icon :color="data.item.color">{{ data.item.icon }}</v-icon>
                </v-avatar>
            </v-flex>
            <v-flex grow class='ml-3'>
                {{ data.item.name }}
            </v-flex>
        </template>
        <template slot="item" slot-scope="data">
            <v-list-tile-avatar>
                <v-img v-if="data.item.image" :src="data.item.image"></v-img>
                <v-icon v-else-if="data.item.icon" :color="data.item.color">{{ data.item.icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
                <v-list-tile-title> {{data.item.name}} </v-list-tile-title>
            </v-list-tile-content>
        </template>
    </v-select>
</template>

<script>
    export default {
        name: "SelectImageChooser",
        props: ["options", "currentSelection", "items"],
        data() {
            return {
                currSel: this.currentSelection
            }
        },
        methods:{
            getCurrentSelection(){
                return this.currSel;
            }
        }
    }
</script>

<style scoped>

</style>